import React from "react";

const Spinner = ({type}) => {
  const className = !type
    ? "spinner big-spinner"
    : type == "small"
    ? "spinner small-spinner"
    : "spinner big-spinner";
  var styleProps = {
    className: className,
  };
  return <div {...styleProps} />;
};

export default Spinner;
